import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  checkbox: css`
    label: checkbox;

    position: relative;
    margin-left: 0.6rem;
  `,
  input: css`
    label: checkbox__input;

    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;

    .lightItalic {
      color: ${colours.font.LIGHT_GRAY};
      font-style: italic;
    }
  `,
  label: (isChecked: boolean, isDisabled: boolean, hasFocus = false): string => css`
    label: checkbox__label;

    position: relative;
    display: block;
    margin-right: ${spacing.XXXS};
    margin-bottom: ${spacing.XS};
    padding-left: ${spacing.XS};
    font-weight: normal;
    font-size: 1.4rem;
    text-align: left;
    cursor: ${isDisabled ? 'default' : 'pointer'};

    &:after {
      position: absolute;
      top: 0.5rem;
      left: 0rem;
      width: 1rem;
      height: 1rem;
      color: ${colours.font.ASSISTIVE};
      line-height: 0.8;
      background: ${colours.font.ASSISTIVE};
      transition: all 0.2s;
      content: '';

      transform: scale(${isChecked ? 1 : 0});
      opacity: ${isChecked ? 1 : 0};
    }

    &:before {
      position: absolute;
      top: 0rem;
      left: -0.5rem;
      width: 2rem;
      height: 2rem;
      background: ${colours.general.WHITE};
      border: 2px solid ${hasFocus ? colours.brand.PRIMARY : colours.border.LIGHT_GRAY};
      content: '';
    }
  `,
};

export default styles;
